
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45 35c0 2.2-1.8 4-4 4H7c-2.2 0-4-1.8-4-4V13c0-2.2 1.8-4 4-4h34c2.2 0 4 1.8 4 4z","fill":"#cfd8dc"}}),_c('path',{attrs:{"d":"M29 16H19c-4.398 0-8 3.602-8 8s3.602 8 8 8h10c4.398 0 8-3.602 8-8s-3.602-8-8-8z","fill":"#1565c0"}}),_c('path',{attrs:{"d":"M19 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm-4 6c0-1.898 1.3-3.398 3-3.898V27.8a3.88 3.88 0 01-3-3.8zm5 3.898V20.2c1.7.403 3 2 3 3.903 0 1.796-1.3 3.296-3 3.796z","fill":"#fff"}})])
          )
        }
      }
    